import { IDescription, ILimitAmountUnit, IProductOptionDTO, OrderType } from "@/interface";

export class AvailableOption {
    public id: number;
    public guid: string;
    public maxCombinations: number;
    public minOption: number;
    public disabled: boolean;
    public price: number;
    public name: string;
    public currentActiveOption: number | boolean;
    public data: ILimitAmountUnit;
    public technicalDescriptions: IDescription | null;
    public descriptions: IDescription;

    constructor(base?: Partial<AvailableOption>) {
        if (base) {
            Object.assign(this, base);
        }
    }

    static fromDto(dto: IProductOptionDTO) {
        return new AvailableOption({
            id: dto.id,
            guid: dto.guid,
            maxCombinations: dto.max_combinations ? dto.max_combinations : 0,
            price: +dto.pricing.price,
            name: dto.name,
            data: dto.data,
            currentActiveOption: dto.data ? 0 : false,
            descriptions: dto.descriptions,
            technicalDescriptions: dto.technical_descriptions ? dto.technical_descriptions : null
        });
    }


    static fromOrderType(dto: OrderType | any) {
        return new AvailableOption({
            id: dto.id,
            guid: dto.guid,
            maxCombinations: 0,
            price: dto.pricing.price || 0,
            name: dto.name,
            data: dto.data,
            currentActiveOption: dto.data ? 0 : false,
            descriptions: dto.descriptions,
            technicalDescriptions: dto.technical_descriptions ? dto.technical_descriptions : null
        });
    }
}